import { createContext } from "react";
import { $TSFixMe } from "types";

export const SettingsContext = createContext<$TSFixMe>(undefined);
